import React, { useEffect, useState } from 'react'
import TopInputs from '../add-request/TopInputs'
import { VariableRequests } from '../VariableRequests';
import SearchFilter from '../add-request/SearchFilter';
import SliderCart from '../add-request/SliderCart';
import Carts from '../add-request/Carts';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';

function EditRequest({ translate,langLocal,activeId }) {
    const { state, setState, setStateCustom, setLoad } = VariableRequests();
    const fakData = {
        requester: {
            value: 1,
            label: 'Requester 1'
        },
        request_date: '2024-02-13',
        needed_on: '2024-02-27',
        Warehouse: {
            value: 1,
            label: 'Warehouse 1'
        },
        received_by: {
            value: 1,
            label: 'person 1'
        },
        phone_number: 933289353,
        company_project: {
            value: 1,
            label: 'Company 1'
        },
        status: {
            value: 1,
            label: 'Status 1'
        },
        request_number: 1235,
        ship_to: "test",
        location: "test",
        notes: 'notes notes',
        items: [
            {
                id: 2,
                name: "Camera 2",
                brand: "XXX",
                model: "yyy",
                category: "Category 2",
                sub_category: "Sub Category 2",
                warehouse: "Warehouse 2",
                Type: "Type 2",
                description: "description descrip desc description descrip desc",
                url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
                qty: 15,
                supplier: "Fadi Ayyas",
                newQty: 3
            },
            {
                id: 3,
                name: "Camera 3",
                brand: "XXX",
                model: "yyy",
                category: "Category 3",
                sub_category: "Sub Category 3",
                warehouse: "Warehouse 3",
                Type: "Type 3",
                description: "description descrip desc description descrip desc",
                url: 'https://i1.adis.ws/i/canon/eos-r7-lifestyle_c604337a3b374a94a080d40b43f3a920?$70-30-header-4by3-dt-jpg$',
                qty: "15",
                supplier: "Fadi Ayyas",
                newQty: 1
            },
        ]
    }
    const [cartArr, setCartArr] = useState(fakData?.items)
    useEffect(() => {
        const temp = {
            ...fakData,
            requester_id: fakData.requester.value,
            warehouse_id: fakData.Warehouse.value,
            received_by: fakData.received_by.value,
            status: fakData.status.value,
            company_project: fakData.company_project.value,
        };
        delete temp?.Warehouse
        delete temp?.requester
        setState(temp);
    }, []);
    return (
        <>
            <main>
                <div className='div_table' >
                    <div className='AddScriptsArchive' >
                        <div className='d-flex' style={{ justifyContent: "space-between" }} >
                            <h3 >{translate('create_order')}</h3>
                            <button className='btn-savee' onClick={() => console.log(state)} >{translate('save')}</button>
                        </div>
                        <br></br>
                        <TopInputs order fakData={fakData} state={state} setStateCustom={setStateCustom} />
                        <SearchFilter translate={translate} langLocal={langLocal} />
                        <SliderCart cartArr={cartArr} setCartArr={setCartArr} />
                        <br></br>
                        <Carts cartArr={cartArr} setCartArr={setCartArr} />
                    </div>
                </div>
            </main>
        </>
    )
}

export default EditRequest